import { useMemo } from 'react'

import { calculateFormDiscounts } from '../../../../functions'

export default function useDiscounts(formData) {
  const { appliedDiscounts, appliedBundleDiscounts, getProductDiscount } = useMemo(
    () => calculateFormDiscounts(formData),
    [formData]
  )

  return {
    appliedDiscounts,
    appliedBundleDiscounts,
    getProductDiscount,
  }
}
